import React from 'react';
import { Box } from '@mui/material';
import TestimonialPageNewContainer from '../../components/testimonial-pages/TestimonialPageNewContainer';

const TestimonialPageNewPage = () => {
  return (
    <Box>
      <TestimonialPageNewContainer />
    </Box>
  )
}

export default TestimonialPageNewPage;
